import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import AthletesUpdateComponent from './component'

export const AthletesUpdate = combine({
  hooks: [
    withContext(
      'adminAthletesService',
      ServicesContext,
      ({ adminAthletesService }) => adminAthletesService
    ),

    withCallbacks(
      {
        getAthleteInfoById:
          ({ adminAthletesService }) =>
          (athleteId) => {
            const content = adminAthletesService.getAthleteById(athleteId)
            return content
          },
        onSubmit:
          ({ adminAthletesService }, { history }) =>
          async (athleteDTO) => {
            await adminAthletesService.updateAthlete(athleteDTO)
            toaster.info('Athlete has been successfully updated')
            history.push(admin.athletes())
          },
      },
      []
    ),
  ],
  transformProps: ({ match, getAthleteInfoById, onSubmit }) => {
    return {
      athleteId: Number(match.params.athleteId),
      getAthleteInfoById,
      onSubmit,
    }
  },
})(AthletesUpdateComponent)
